// Espejo del enum BiometryType del plugin. Se exporta para que la UI elija el icono sin repetir
// numeros magicos. Verificado en dispositivo: Android reporta 3, iPhone 2, iPad 1.
export const BIOMETRY_TYPE = {
  NONE: 0,
  TOUCH_ID: 1,
  FACE_ID: 2,
  FINGERPRINT: 3,
  FACE_AUTHENTICATION: 4,
  IRIS_AUTHENTICATION: 5,
  MULTIPLE: 6
}
